import { render, staticRenderFns } from "./IssuePriorityTableCell.vue?vue&type=template&id=ba5a53c6&scoped=true"
import script from "./IssuePriorityTableCell.vue?vue&type=script&lang=js"
export * from "./IssuePriorityTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssuePriorityTableCell.vue?vue&type=style&index=0&id=ba5a53c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5a53c6",
  null
  
)

export default component.exports